import { IconName } from "@zapier/design-system";
import { ZapCardTemplate } from "../ZapCard";
import { BreadCrumbItem } from "../BreadCrumbs";

type ZSLAssetType = {
  name: string;
  displayName: string;
  icon: IconName;
};

export const ZSL_ASSET_TYPES: ZSLAssetType[] = [
  {
    name: "zaps",
    displayName: "Zaps",
    icon: "miscBoltAltFill",
  },
  {
    name: "tables",
    displayName: "Tables",
    icon: "navTables",
  },
  {
    name: "interfaces",
    displayName: "Interfaces",
    icon: "navInterfaces",
  },
  {
    name: "chatbots",
    displayName: "Chatbots",
    icon: "navAIChatbot",
  },
  {
    name: "canvases",
    displayName: "Canvases",
    icon: "navCanvas",
  },
];

type TemplateLibraryType = "Interfaces" | "Tables" | "Chatbot";

export const getBreadcrumbs = (template: ZapCardTemplate): BreadCrumbItem[] => {
  let templateType: TemplateLibraryType = "Interfaces";
  if (
    template.products?.items.some((p) => p.slug === "tables") &&
    !template.products?.items.some((p) => p.slug === "interfaces")
  )
    templateType = "Tables";

  if (
    (template.products?.items.some((p) => p.slug === "chatbot") &&
      !template.products?.items.some((p) => p.slug === "interfaces")) ||
    template.primaryProduct === "chatbot"
  )
    templateType = "Chatbot";

  return [
    { text: "Templates", href: "/templates" },
    {
      text: templateType,
      href: `/templates/${templateType.toLowerCase()}`,
    },
    { text: template.name },
  ];
};

export type Param = {
  key: string;
  default: string;
};

export const replaceParamsInTitle = (title: string, params: Param[]) => {
  const TEMPLATE_PARAM_REGEX = /\$\{\{ *([A-Za-z0-9_.]+) *\}\}/g;
  return title.replace(TEMPLATE_PARAM_REGEX, (match, parameterName) => {
    const key = parameterName.split(".").pop() || parameterName;
    const param = params.find((p) => p.key === key);
    return param?.default || match;
  });
};
